import { addDays, isAfter, isBefore, startOfToday } from 'date-fns';
import { FC } from 'react';
import { useController, useFormContext } from 'react-hook-form';

import { CalendarOutline, DatePicker } from '@bonusly/design-system';

interface DateInputProps {
	availableRangeDays?: number;
}

export const DateInput: FC<DateInputProps> = ({ availableRangeDays = 30 }) => {
	const { control } = useFormContext();
	const { field: meetingDate } = useController({
		name: 'meetingDate',
		control,
	});
	const { field: dayOfWeek } = useController({ name: 'dayOfWeek', control });
	const today = startOfToday();

	const selectDate = (date: Date | null) => {
		meetingDate.onChange(date);
		if (date) {
			dayOfWeek.onChange(date.getDay());
		}
	};

	return (
		<DatePicker
			onChange={selectDate}
			value={meetingDate.value}
			leftIcon={<CalendarOutline color="text.default" />}
			disableDateIf={(date: Date) => isBefore(date, today) || isAfter(date, addDays(today, availableRangeDays))}
		/>
	);
};
